/**
 * EditWorkOrderWrapper
 *
 * Purpose:
 * - Wraps WO edit page to stay within vendor orders context.
 * - Uses returnTab for back navigation and intercepts list navigation.
 */
import React from "react";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { CONTRACTORS, WORK_ORDER, VENDOR, VENDOR_ORDERS } from "../../constants/route-paths";
import CreateWorkOrder from '../projects/project-execution/create-work-order';
import { VENDOR_TAB, VENDOR_URL_PARAM } from "../../constants/vendor.contant";

function EditWorkOrderWrapper(props) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const params = useParams();
  
  const returnTab = searchParams.get(VENDOR_URL_PARAM.RETURN_TAB) || VENDOR_TAB.WORK_ORDERS;
  const returnSubTab = searchParams.get(VENDOR_URL_PARAM.RETURN_SUB_TAB);

  // Custom navigate function that intercepts WO list navigation
  const customNavigate = (path) => {
    if (returnTab && path === `/${CONTRACTORS}/${WORK_ORDER}`) {
      // Redirect to vendor orders with the correct tab and sub-tab
      let url = `/${VENDOR}/${VENDOR_ORDERS}?${VENDOR_URL_PARAM.TAB}=${returnTab}`;
      if (returnSubTab) {
        url += `&${VENDOR_URL_PARAM.SUB_TAB}=${returnSubTab}`;
      }
      navigate(url);
    } else {
      navigate(path);
    }
  };

  return (
    <CreateWorkOrder
      {...props}
      params={params}
      customNavigate={customNavigate}
    />
  );
}

export default EditWorkOrderWrapper;
